import { render, staticRenderFns } from "./DocumentsTexts.vue?vue&type=template&id=0bf63806&"
import script from "./DocumentsTexts.vue?vue&type=script&lang=js&"
export * from "./DocumentsTexts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports